import { DragDropContext, DropResult } from "@hello-pangea/dnd";
import { FC } from "react";
import { AiOutlineOrderedList } from "react-icons/ai";
import { CgAddR } from "react-icons/cg";

import Spinner from "components/Spinner/Spinner";
import SimpleButton from "global/SimpleButton/SimpleButton";
import QuestionBank from "../../components/QuestionBank";
import SelectedQuestions from "../../components/SelectedQuestions";
import { Question } from "../types";
import SectionCard from "./SectionCard";

interface QuestionsWorkspaceProps {
  onDragEnd: (result: DropResult) => void;
  questionLoading: boolean;
  availableQuestions: Question[];
  selectedQuestionIds: number[];
  onAddQuestion: (question: Question) => void;
  onOpenQuestionBank: () => void;
  selectedQuestions: Question[];
  dependencyState: Record<
    number,
    { parentQuestionId: number; contentId: number[]; isRequired: boolean }
  >;
  onDependencyChange: (
    questionId: number,
    parentQuestionId: number,
    contentId: number[]
  ) => void;
  onRequiredChange: (questionId: number, required: boolean) => void;
  onDeleteQuestion: (id: number) => void;
  onDeleteAll: () => void;
}

const QuestionsWorkspace: FC<QuestionsWorkspaceProps> = ({
  onDragEnd,
  questionLoading,
  availableQuestions,
  selectedQuestionIds,
  onAddQuestion,
  onOpenQuestionBank,
  selectedQuestions,
  dependencyState,
  onDependencyChange,
  onRequiredChange,
  onDeleteQuestion,
  onDeleteAll,
}) => {
  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <div className="grid grid-cols-1 xl:grid-cols-12 gap-6 mt-6">
        {/* Question Bank */}
        <div className="xl:col-span-8">
          <SectionCard
            title="بانک سوالات"
            subTitle="سوالات را انتخاب یا Drag کنید و به فرم اضافه نمایید"
            icon={<CgAddR size={22} />}
            actions={
              <SimpleButton
                type="button"
                text={"افزودن سوال جدید"}
                className="w-auto px-5 !py-2.5 !rounded-2xl !bg-[#7a1b2b] !text-white hover:opacity-90"
                handelClick={onOpenQuestionBank}
                rightIcon={<CgAddR />}
              />
            }
          >
            <div className="min-h-[420px]">
              {questionLoading ? (
                <div className="flex items-center justify-center min-h-[300px]">
                  <Spinner />
                </div>
              ) : (
                <QuestionBank
                  questions={availableQuestions}
                  selectedQuestionIds={selectedQuestionIds}
                  onAddQuestion={onAddQuestion}
                />
              )}
            </div>
          </SectionCard>
        </div>

        {/* Selected Questions */}
        <div className="xl:col-span-4">
          <SectionCard
            title="سوالات انتخاب‌شده"
            subTitle="مرتب‌سازی، وابستگی و اجباری بودن سوالات"
            icon={<AiOutlineOrderedList size={22} />}
            actions={
              <button
                type="button"
                onClick={onDeleteAll}
                className="text-xs px-4 py-2 rounded-xl border border-red-100 text-red-500 bg-white hover:bg-red-50 transition"
              >
                حذف همه
              </button>
            }
          >
            <div className="min-h-[420px]">
              <SelectedQuestions
                selectedQuestions={selectedQuestions}
                dependencyState={dependencyState}
                onDependencyChange={onDependencyChange}
                onRequiredChange={onRequiredChange}
                onDeleteQuestion={onDeleteQuestion}
              />
            </div>
          </SectionCard>
        </div>
      </div>
    </DragDropContext>
  );
};

export default QuestionsWorkspace;
